export default __webpack_public_path__ + "static/media/email.8844dc6c.png";